"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportIssueHandler = exports.reportUserHandler = void 0;
const support_1 = require("../http/support");
const reportUserHandler = (reportedUser, reportMessage, navigate) => {
    (0, support_1.reportUser)(reportedUser, reportMessage).then(_ => {
        navigate();
    }).catch(error => {
        console.log(error);
    });
};
exports.reportUserHandler = reportUserHandler;
const reportIssueHandler = (reportMessage, navigate) => {
    (0, support_1.reportIssue)(reportMessage).then(_ => {
        navigate();
    }).catch(error => {
        console.log(error);
    });
};
exports.reportIssueHandler = reportIssueHandler;
